import { action, computed, extendObservable, makeObservable, observable, runInAction, when } from 'mobx';
import AdvogadoSustentacaoOralService from '@/service/AdvogadoSustentacaoOralService';
import AnotacaoService from '../service/AnotacaoService';
import AssinaturaService from '../service/AssinaturaService';
import CertidaoService from '../service/CertidaoService';
import ClienteEnvelopeService from '../service/ClienteEnvelopeService';
import FotoMagistradoService from '../service/FotoMagistradoService';
import LoginService from '../service/LoginService';
import MovimentoCNJService from '../service/MovimentoCNJService';
import PecasService from '../service/PecasServico';
import ProcessoService from '../service/ProcessoService';
import SecretariaService from '../service/SecretariaService';
import SessaoService from '../service/SessaoService';
import SustentacoesService from '../service/SustentacoesService';
import TipoJulgamentoService from '../service/TipoJulgamentoService';
import Ambiente from '../util/Ambiente';
import Configuracao from '../util/Configuracao';
import ErrorUtil from '../util/ErrorUtil';
import StorageUtil from '../util/StorageUtil';
import { ABAS_DETALHES_PROCESSO } from '@/dominio/AbasDetalhesProcesso';
import CalendarioService from '@/service/CalendarioService';

export default class Store {
    idProcessosEmExibicao = 'P';
    processoScroll = undefined;
    processoExpandido = undefined;
    processoModal = undefined;

    abaSelecionadaDetalhesProcesso = ABAS_DETALHES_PROCESSO.PROCESSO.id;

    filtros;
    painelFiltros = false;
    alterandoValorFiltro = false;
    valorCampoPesquisaFiltros = '';

    progressoProcessamentoLote;
    dialogProgressoProcessamentoLote = false;
    fecharProgressoAutomaticamente = false;

    /** @type {boolean | undefined} */
    carregandoProcessos = undefined;

    /** @type {boolean | undefined} */
    carregandoMovimentosDecisoes = undefined;

    /** @type {Map} */
    carregandoDetalhesProcesso = observable.map();

    offsetScroll = {};

    rootStore;
    disposers = [];

    processoService = new ProcessoService();
    sessaoService = new SessaoService();
    pecasService = new PecasService();
    loginService = new LoginService();
    anotacaoService = new AnotacaoService();
    assinaturaService = new AssinaturaService();
    certidaoService = new CertidaoService();
    secretariaService = new SecretariaService();
    movimentoCNJService = new MovimentoCNJService();
    clienteEnvelopeService = new ClienteEnvelopeService();
    tiposJulgamentoService = new TipoJulgamentoService();
    advogadoSustentacaoOralService = new AdvogadoSustentacaoOralService();
    sustentacoesService = new SustentacoesService();
    fotoMagistradoService = new FotoMagistradoService();
    calendarioService = new CalendarioService();

    execucaoEmLoteEmProcessamento = false;

    checkedOperacoesEmLote = new Set();
    checkedOperacoesEmLotePartes = new Map();

    constructor(rootStore) {
        makeObservable(this, {
            idProcessosEmExibicao: observable,
            processoScroll: observable,
            processoExpandido: observable,
            processoModal: observable,
            abaSelecionadaDetalhesProcesso: observable,
            filtros: observable,
            painelFiltros: observable,
            alterandoValorFiltro: observable,
            valorCampoPesquisaFiltros: observable,
            progressoProcessamentoLote: observable,
            dialogProgressoProcessamentoLote: observable,
            fecharProgressoAutomaticamente: observable,
            carregandoProcessos: observable,
            carregandoMovimentosDecisoes: observable,
            execucaoEmLoteEmProcessamento: observable,
            checkedOperacoesEmLote: observable,
            checkedOperacoesEmLotePartes: observable,
            inicializar: action,
            inicializarAtributosStorage: action,
            inicializarFiltros: action,
            reset: action,
            resetFiltros: action,
            adicionarObservable: action,
            carregarAlertasImpedimento: action,
            configurarProcessoExpandido: action,
            processosSessao: computed,
            processosSessaoOrdenados: computed,
            existeFiltroAtivo: computed,
            existeFiltroBooleanoAtivo: computed,
            existeFiltroRapidoAtivo: computed,
            alterarProcessosEmExibicao: action,
            alterarSelecaoProcessos: action,
            exibirProgressoLote: action,
            inicializarProcessamentoLote: action,
            executarProcessamentoLote: action,
            finalizarProcessamentoLoteSemTelaProgresso: action,
            finalizarProcessamentoLote: action,
            atualizarProcessamentoLote: action,
            incrementarProgressoLote: action,
            fecharProgressoLoteSucesso: action,
            verificarRegistrosNaoProcessados: action,
            atualizarProcessoExpandido: action,
            mapaProcessosPartes: computed,
            processosFiltrados: computed,
            relatoresSessao: computed,
            relatoresSessaoComFiltro: computed,
            carregarPecas: action,
            carregarDetalhesProcesso: action,
            complementarMovimentos: action,
            getMapaProcessosPartes: action,
            abrirProcesso: action,
            disposeReactions: action,
            processarLote: action,
            processoSelecionado: computed,
            resetCheckedOperacoesEmLotePartes: action,
            checkAllOperacoesEmLotePartes: action,
            checkOperacoesEmLotePartes: action,
            uncheckOperacoesEmLotePartes: action,
            processarLote: action
        });

        this.rootStore = rootStore;
    }

    inicializar() {
        this.inicializarAtributosStorage();
    }

    async inicializarAtributosStorage() {
        if (this.objetoLocalStorage) {
            let storage = await StorageUtil.getObject(this.nomeStorage, this.storageType);

            if (storage) {
                for (let key in this.objetoLocalStorage) {
                    this[key] = storage[key];
                }
            }
        }
    }

    inicializarFiltros(novosFiltros) {
        this.filtros = novosFiltros();
    }

    reset() {
        this.painelFiltros = false;
        this.resetFiltros();
    }

    resetFiltros = () => {
        if (this.filtros) {
            this.filtros.reset();
            this.offsetScroll = {};
        }
    };

    /**
     * @returns {string} O nome composto da storage utilizado como chave no localStorage.
     */
    get nomeStorage() {
        return this.objetoLocalStorage.nomeStore + this.cpfUsuarioStorage;
    }

    /**
     * @returns {string} O CPF do usuário logado para composição da chave no localStorage
     */
    get cpfUsuarioStorage() {
        return this.rootStore.usuarioStore.usuario && this.rootStore.usuarioStore.usuario.cpf
            ? `-${this.rootStore.usuarioStore.usuario.cpf}`
            : '';
    }

    get sessaoStore() {
        return this.rootStore.sessaoStore;
    }

    get dominioStore() {
        return this.rootStore.dominioStore;
    }

    get fotoMagistradoStore() {
        return this.rootStore.fotoMagistradoStore;
    }

    get usuarioStore() {
        return this.rootStore.usuarioStore;
    }

    get appStore() {
        return this.rootStore.appStore;
    }

    get storeFuncionalidade() {
        return this.rootStore[this.rootStore.routerStore.storeRotaAtual];
    }

    get processoSelecionado() {
        return this.processoModal || this.processoExpandido;
    }

    save = (json) => {
        if (this.objetoLocalStorage && this.rootStore.usuarioStore.isUsuarioLogado) {
            StorageUtil.setItem(this.nomeStorage, JSON.stringify(json), this.storageType);
        }
    };

    setTimeout(funcao) {
        return setTimeout(runInAction(funcao), 1);
    }

    cancelarRequisicoesPendentes() {
        Ambiente.cancelarRequisicoes();
        this.rootStore.appStore.zerarRequisicoes();
    }

    adicionarObservable(objeto, propriedade, valor) {
        if (!Object.prototype.hasOwnProperty.call(objeto, propriedade)) {
            extendObservable(objeto, {
                [propriedade]: valor
            });
        }
    }

    async carregarAlertasImpedimento(registro) {
        if (registro && registro.processo && registro.processo.numeroCompleto && this.isProcessoPje(registro)) {
            let alertasImpedimento = await this.processoService.recuperarAlertasImpedimento(
                registro.sessaoId,
                registro.numeroProcesso
            );
            runInAction(() => {
                registro.alertasImpedimento = alertasImpedimento;
            });
        }
    }

    configurarProcessoExpandido() {
        if (this.processosSessao) {
            let numeroProcessoExpandidoAnterior = this.processoExpandido
                ? this.processoExpandido.numeroProcesso
                : undefined;
            this.processoExpandido = this.processosSessao.find(
                (registro) => registro.numeroProcesso === numeroProcessoExpandidoAnterior
            );
        }
    }

    get processosSessao() {
        return this.sessaoStore.sessaoSelecionada && this.sessaoStore.sessaoSelecionada.processos
            ? this.processosSessaoOrdenados
            : [];
    }

    get processosSessaoOrdenados() {
        return this.sessaoStore.sessaoSelecionada.processos
            .slice()
            .sort((r1, r2) => (r1.ordemSessao < r2.ordemSessao ? -1 : 1));
    }

    isProcessoPje(registro) {
        return registro && registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    get existeFiltroAtivo() {
        return this.filtros?.existeFiltroComValor;
    }

    get existeFiltroBooleanoAtivo() {
        return this.filtros?.existeFiltroBooleanoComValor;
    }

    get existeFiltroRapidoAtivo() {
        return this.filtros?.existeFiltroRapidoComValorPadrao;
    }

    alterarProcessosEmExibicao = (idProcessosEmExibicao) => {
        if (this.idProcessosEmExibicao !== idProcessosEmExibicao) {
            setTimeout(() => this.alterarSelecaoProcessos(idProcessosEmExibicao), 1);
        }
    };

    alterarSelecaoProcessos = (idProcessosEmExibicao) => {
        this.idProcessosEmExibicao = idProcessosEmExibicao;
    };

    exibirProgressoLote(progressoProcessamentoLote) {
        this.progressoProcessamentoLote = progressoProcessamentoLote;
        this.dialogProgressoProcessamentoLote = !progressoProcessamentoLote.ocultarProcessamentoLote;
    }

    async processarLote(config) {
        if (this.execucaoEmLoteEmProcessamento) {
            console.warn('Já existe um processamento em lote sendo executado.');
            return;
        }

        this.execucaoEmLoteEmProcessamento = true;

        this.inicializarProcessamentoLote(
            config.qtdTotalProcessos,
            config.titulo,
            config.indeterminate,
            config.ocultarProcessamentoLote
        );

        const resultadoProcessamento = await this.executarProcessamentoLote(config);

        if (this.finalizarProcessamentoLote(resultadoProcessamento, config.ocultarProcessamentoLote)) {
            const msg = config?.mensagemSucesso ? config.mensagemSucesso : 'Operação em lote realizada com sucesso.';
            this.rootStore.mensagemStore.abrirMensagemSucesso(msg);
        } else {
            console.error(`Falha na operação em lote "${config.titulo}".`);
        }

        this.execucaoEmLoteEmProcessamento = false;

        return resultadoProcessamento;
    }

    inicializarProcessamentoLote(qtdTotalProcessos, titulo, indeterminate, ocultarProcessamentoLote = false) {
        this.exibirProgressoLote({
            descricao: titulo,
            quantidadeTotal: qtdTotalProcessos,
            quantidadeProcessados: 0,
            resultadoProcessamento: [],
            indeterminate: indeterminate,
            ocultarProcessamentoLote: ocultarProcessamentoLote
        });
    }

    async executarProcessamentoLote(config) {
        const QTD_PROMISES_PADRAO = 5;
        const qtdPromisesParalelas = config.qtdPromisesParalelas ? config.qtdPromisesParalelas : QTD_PROMISES_PADRAO;
        let lotesProcessos = config.lotesProcessos;
        let resultadoProcessamento = [];
        let resultado;
        lotesProcessos = lotesProcessos.slice();

        while (lotesProcessos.length) {
            let lote = lotesProcessos.splice(0, qtdPromisesParalelas);
            let promises = [];

            for (let index in lote) {
                promises.push(config.funcaoOperacao(lote[index]));
            }

            resultado = await Promise.all(promises);
            resultadoProcessamento = this.processarResultado(resultado, resultadoProcessamento);
        }

        return resultadoProcessamento;
    }

    processarResultado(resultado, resultadoProcessamento) {
        resultado.forEach((result) => {
            resultadoProcessamento = resultadoProcessamento.concat(result);
        });

        return resultadoProcessamento;
    }

    finalizarProcessamentoLoteSemTelaProgresso(resultadoProcessamento) {
        return this.finalizarProcessamentoLote(resultadoProcessamento, true);
    }

    finalizarProcessamentoLote(resultadoProcessamento, ocultarProcessamentoLote = false) {
        if (resultadoProcessamento) {
            const sucesso = this.isResultadoSucesso(resultadoProcessamento);

            if (this.progressoProcessamentoLote) {
                this.progressoProcessamentoLote.resultadoProcessamento = resultadoProcessamento;
            }

            if (sucesso && !ocultarProcessamentoLote) {
                this.fecharProgressoLoteSucesso();
            }

            return sucesso;
        }

        return false;
    }

    isResultadoSucesso(resultadoProcessamento) {
        if (!resultadoProcessamento || !Array.isArray(resultadoProcessamento)) {
            return false;
        }

        return resultadoProcessamento.findIndex((resultado) => this.isResultadoErro(resultado)) === -1;
    }

    contemAlgumResultadoSucesso(resultadoProcessamento) {
        if (!resultadoProcessamento || !Array.isArray(resultadoProcessamento)) {
            return false;
        }

        return resultadoProcessamento.some((resultado) => !this.isResultadoErro(resultado));
    }

    atualizarProcessamentoLote(resultado) {
        if (this.progressoProcessamentoLote) {
            this.progressoProcessamentoLote.quantidadeProcessados += resultado.length;
        }
    }

    incrementarProgressoLote() {
        if (this.progressoProcessamentoLote) {
            this.progressoProcessamentoLote.quantidadeProcessados++;
        }
    }

    fecharProgressoLoteSucesso() {
        if (this.fecharProgressoAutomaticamente) {
            setTimeout(() => runInAction(() => (this.dialogProgressoProcessamentoLote = false)), 1000);
        }
    }

    verificarRegistrosNaoProcessados(processos, resultadoProcessamento) {
        if (processos.length !== resultadoProcessamento.length) {
            let naoProcessados = processos.filter(
                (registro) =>
                    resultadoProcessamento.findIndex(
                        (resultado) => resultado.numeroProcesso === registro.processo.numeroCompleto
                    ) === -1
            );

            let resultadoNaoProcessados = naoProcessados.map((np) => ({
                numeroProcesso: np.processo.numeroCompleto,
                erro: true,
                mensagem: ' O registro não foi processado'
            }));

            resultadoProcessamento = resultadoProcessamento.concat(resultadoNaoProcessados);
        }
    }

    atualizarProcessoExpandido(registro) {
        if (
            this.processoExpandido &&
            registro &&
            this.processoExpandido.processo.numeroCompleto === registro.processo.numeroCompleto
        ) {
            this.processoExpandido = registro;
        }
    }

    isSessaoSIJ(idSessao) {
        return idSessao && idSessao.toString().toLowerCase().indexOf(Configuracao.ORIGEM_SIJ.toLowerCase()) > -1;
    }

    isSessaoPJe(idSessao) {
        return idSessao && idSessao.toString().toLowerCase().indexOf(Configuracao.ORIGEM_PJE.toLowerCase()) > -1;
    }

    isSessaoMista() {
        return this.existeSessaoSIJ && this.existeSessaoPJe;
    }

    // Não adicionar computed aqui
    get sessoesSessaoSelecionada() {
        return (this.sessaoStore.sessaoSelecionada && this.sessaoStore.sessaoSelecionada.sessoes) || [];
    }

    get existeSessaoSIJ() {
        return this.sessoesSessaoSelecionada.find((sessao) => sessao.origem === Configuracao.ORIGEM_SIJ);
    }

    get existeSessaoPJe() {
        return this.sessoesSessaoSelecionada.find((sessao) => sessao.origem === Configuracao.ORIGEM_PJE);
    }

    getSessaoSessaoSelecionada(sessaoId) {
        return this.sessoesSessaoSelecionada.find((sessao) => sessao.id === sessaoId);
    }

    get certidaoHabilitada() {
        return this.rootStore.parametroStore.usaCertidao();
    }

    // Implementar na store que utiliza o filtro de partes.
    get mapaProcessosPartes() {
        return {};
    }

    // Implementar na store que utiliza filtros.
    get processosFiltrados() {
        return [];
    }

    get relatoresSessao() {
        return this.filtrarRelatores(this.processosSessao);
    }

    get relatoresSessaoComFiltro() {
        return this.filtrarRelatores(this.processosFiltrados);
    }

    filtrarRelatores(processos) {
        let relatores = [];
        processos.forEach((registro) => {
            if (registro.processo.relator) {
                let value = this.filtros.filtroNomeRelator.getValorOpcao(registro);

                if (relatores.findIndex((relator) => relator === value) === -1) {
                    relatores.push(value);
                }
            }
        });
        return relatores;
    }

    getLabelRelator = (value) => {
        return this.filtros && this.filtros.filtroNomeRelator.getDescricao(value);
    };

    getRelator = (value) => {
        const splitValue = value.split('||');
        return { sigla: splitValue[0], cpf: splitValue[1].replace(/[\\.-]/g, ''), nome: splitValue[2] };
    };

    /**
     * Retorna a ordem de antiguidade do magistrado.
     *
     * @param {string} siglaMagistrado A sigla do magistrado
     * @returns {number} A antiguidade do relator
     */
    getAntiguidade(siglaMagistrado) {
        let antiguidade;

        if (siglaMagistrado && this.sessaoStore?.sessaoSelecionada?.antiguidade) {
            antiguidade = this.sessaoStore.sessaoSelecionada.antiguidade[siglaMagistrado];
        }

        return Number.isFinite(antiguidade) ? antiguidade : 999999;
    }

    /**
     * Retorna a ordem de antiguidade do magistrado.
     * Caso não exista informação de antiguidade, coloca o magistrado no final da lista.
     *
     * @param {string} relator A identificação do relator, no formato "siglaOJ||cpf||nome"
     * @returns {number} A antiguidade do relator
     */
    antiguidadeRelator(relator) {
        let antiguidade;

        if (this.sessaoStore?.sessaoSelecionada?.antiguidade) {
            const relatorObj = this.getRelator(relator);

            if (relatorObj?.sigla) {
                antiguidade = this.sessaoStore.sessaoSelecionada.antiguidade[relatorObj.sigla];
            }
        }

        return antiguidade || 999999;
    }

    async carregarPecas(registro, sessaoId) {
        if (registro?.processo?.numeroCompleto) {
            let pecas = await this.pecasService.recuperarPecasPorProcesso(
                sessaoId || registro.sessaoId,
                registro.numeroProcesso
            );
            runInAction(() => {
                pecas.forEach((peca) => extendObservable(peca, { open: false, sublinhado: '' }));
                registro.pecas = pecas;
            });
        }
    }

    getChaveControleCarregamentoDetalhes(registro) {
        if (!registro?.sessaoId) {
            console.log('Registro sem número de sessão.');
            return '';
        }

        if (!registro?.processo?.numeroCompleto) {
            console.warn('Registro sem número de processo.');
            return '';
        }

        return `${registro.processo.numeroCompleto}|${registro.sessaoId}`;
    }

    async carregarDetalhesProcesso(registro) {
        if (registro?.processo?.numeroCompleto) {
            let versao = 0;

            const controleCarregamentoDetalhes = this.carregandoDetalhesProcesso.get(
                this.getChaveControleCarregamentoDetalhes(registro)
            );

            if (controleCarregamentoDetalhes) {
                versao = controleCarregamentoDetalhes.versaoCarregamento + 1;
            }

            try {
                runInAction(() => {
                    this.carregandoDetalhesProcesso.set(this.getChaveControleCarregamentoDetalhes(registro), {
                        numeroCompleto: registro.processo.numeroCompleto,
                        sessaoId: registro.sessaoId,
                        carregando: true,
                        versaoCarregamento: versao
                    });
                });

                console.log(`Carregando detalhes do processo ${registro.processo.numeroCompleto}...`);
                let detalhes = await this.processoService.recuperarDetalhesProcessoSessao(
                    registro.processo.numeroCompleto,
                    registro.sessaoId
                );

                await this.complementarMovimentosJulgamentosAnteriores(detalhes, registro);

                if (!detalhes.julgamentoAnterior && registro.detalhes?.julgamentoAnterior) {
                    detalhes.julgamentoAnterior = registro.detalhes.julgamentoAnterior;
                }
                if (!detalhes.julgamentosAnteriores && registro.detalhes?.julgamentosAnteriores) {
                    detalhes.julgamentosAnteriores = registro.detalhes.julgamentosAnteriores;
                }

                runInAction(() => {
                    registro.detalhes = detalhes;
                });
            } finally {
                runInAction(() => {
                    this.carregandoDetalhesProcesso.set(this.getChaveControleCarregamentoDetalhes(registro), {
                        numeroCompleto: registro.processo.numeroCompleto,
                        sessaoId: registro.sessaoId,
                        carregando: false,
                        versaoCarregamento: versao
                    });
                    console.log(`Detalhes do processo ${registro.processo.numeroCompleto} carregados.`);
                });
            }
        }
    }

    async complementarMovimentosJulgamentosAnteriores(detalhes, registro) {
        if (detalhes?.julgamentoAnterior && registro.processo.origem === Configuracao.ORIGEM_PJE) {
            for (let julgamentoAnterior of detalhes.julgamentosAnteriores) {
                await this.complementarMovimentos(julgamentoAnterior.movimentos);
            }
        }
    }

    async complementarMovimentos(movimentos) {
        if (movimentos && movimentos.length > 0) {
            movimentos = movimentos
                .slice()
                .sort((m1, m2) => (m1.numeroOrdemMovimento < m2.numeroOrdemMovimento ? -1 : 1));

            for (let index in movimentos) {
                await this.rootStore.dominioStore.complementarInformacoesMovimento(movimentos[index]);
            }
        }
    }

    getMapaProcessosPartes(partes, sessaoId) {
        let mapa = {};
        let parte;
        let partesArray = Array.from(partes);

        if (partesArray) {
            partesArray.forEach((partesProcesso) => {
                if (!partesProcesso.partesProcessuais) {
                    return;
                }

                mapa[partesProcesso.numeroCompleto] = {};
                mapa[partesProcesso.numeroCompleto].sessaoId =
                    sessaoId || this.getSessaoProcesso(partesProcesso.numeroCompleto);
                mapa[partesProcesso.numeroCompleto].quantidadePartesAutoras = partesProcesso.quantidadePartesAutoras;
                mapa[partesProcesso.numeroCompleto].partes = [];
                partesProcesso.partesProcessuais.forEach((parteProcessual) => {
                    parteProcessual.partes.forEach((parteProcesso) => {
                        parte = parteProcesso.parte;
                        parte.nome = parte.nome ? parte.nome.trim() : '';
                        parte.entePublico = parteProcesso.entePublico;
                        parte.intimarViaMaloteDigital = parteProcesso.intimarViaMaloteDigital;
                        parte.quantidadeRepresentantes = parteProcesso.quantidadeRepresentantes;
                        parte.denominacao = parteProcessual.denominacao;
                        parte.tipoPolo = parteProcessual.tipoPolo;
                        parte.procuradoria = parteProcesso.procuradoria;
                        parte.registroComplementar = parteProcesso.registroComplementar;
                        parte.semInformacaoIntimacao = parteProcesso.semInformacaoIntimacao;
                        parte.advogadoSemOab = parteProcesso.advogadoSemOab;
                        parte.procuradorSemOab = parteProcesso.procuradorSemOab;
                        mapa[partesProcesso.numeroCompleto].partes.push(parte);
                    });
                });
            });
        }
        return mapa;
    }

    getSessaoProcesso(numeroCompleto) {
        if (
            this.sessaoStore?.idSessaoSelecionada &&
            this.sessaoStore.sessaoSelecionada?.processos &&
            this.sessaoStore.idSessaoSelecionada.indexOf('----')
        ) {
            // Sessão composta

            let registro = this.sessaoStore.sessaoSelecionada.processos.find(
                (reg) => reg.processo.numeroCompleto === numeroCompleto
            );

            if (registro) {
                return registro.sessaoId;
            }
        }
        return this.sessaoStore.idSessaoSelecionada;
    }

    isObjetoVazio(obj) {
        return !obj || Object.keys(obj).length === 0;
    }

    normalizarString(string) {
        return string
            ? (string + '')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
            : '';
    }

    isComponenteHabilitado(nomeComponente) {
        return this.rootStore.parametroStore.isComponenteHabilitado(nomeComponente);
    }

    resetCheckedOperacoesEmLote() {
        this.checkedOperacoesEmLote.clear();
    }

    isCheckedOperacoesEmLote(registro) {
        return this.checkedOperacoesEmLote.has(registro.numeroProcesso);
    }

    checkOperacoesEmLote(registro) {
        this.checkedOperacoesEmLote.add(registro.numeroProcesso);
    }

    uncheckOperacoesEmLote(registro) {
        this.checkedOperacoesEmLote.delete(registro.numeroProcesso);
    }

    checkedOperacoesEmLotePartesToList() {
        let retorno = [];
        for (const numero of this.checkedOperacoesEmLotePartes.keys()) {
            const partes = this.checkedOperacoesEmLotePartes.get(numero);
            for (const parte of partes) {
                retorno.push({
                    numero: numero,
                    parte: parte
                });
            }
        }
        return retorno;
    }

    quantidadePartesCheckedOperacoesEmLotePartes() {
        let quantidade = 0;
        for (const numero of this.checkedOperacoesEmLotePartes.keys()) {
            quantidade += this.checkedOperacoesEmLotePartes.get(numero).length;
        }
        return quantidade;
    }

    quantidadeProcessosCheckedOperacoesEmLotePartes() {
        return this.checkedOperacoesEmLotePartes.size;
    }

    toggleCheckedOperacoesEmLote(registro) {
        if (this.isCheckedOperacoesEmLote(registro)) {
            this.uncheckOperacoesEmLote(registro);
        } else {
            this.checkOperacoesEmLote(registro);
        }
    }

    resetCheckedOperacoesEmLotePartes() {
        this.checkedOperacoesEmLotePartes.clear();
    }

    checkAllOperacoesEmLotePartes(partesSelecionaveis) {
        this.checkedOperacoesEmLotePartes.clear();
        for (const key of partesSelecionaveis.keys()) {
            const partes = partesSelecionaveis.get(key);
            this.checkedOperacoesEmLotePartes.set(key, partes);
        }
    }

    isCheckedOperacoesEmLotePartes(numeroProcesso, parte) {
        const retorno =
            this.checkedOperacoesEmLotePartes.has(numeroProcesso) &&
            (parte
                ? this.checkedOperacoesEmLotePartes.get(numeroProcesso).findIndex((p) => parte.codigo === p.codigo) >= 0
                : true);
        return retorno;
    }

    checkOperacoesEmLotePartes(numeroProcesso, parte) {
        if (!this.checkedOperacoesEmLotePartes.has(numeroProcesso)) {
            this.checkedOperacoesEmLotePartes.set(numeroProcesso, [parte]);
        } else {
            let partes = this.checkedOperacoesEmLotePartes.get(numeroProcesso);
            partes.push(parte);
            this.checkedOperacoesEmLotePartes.set(numeroProcesso, partes);
        }
    }

    uncheckOperacoesEmLotePartes(numeroProcesso, parte) {
        if (this.checkedOperacoesEmLotePartes.has(numeroProcesso)) {
            let partes = this.checkedOperacoesEmLotePartes.get(numeroProcesso).filter((p) => p.codigo !== parte.codigo);
            if (partes.length === 0) {
                this.checkedOperacoesEmLotePartes.delete(numeroProcesso);
            } else {
                this.checkedOperacoesEmLotePartes.set(numeroProcesso, partes);
            }
        }
    }

    toggleCheckedOperacoesEmLotePartes(numeroProcesso, parte) {
        if (this.isCheckedOperacoesEmLotePartes(numeroProcesso, parte)) {
            this.uncheckOperacoesEmLotePartes(numeroProcesso, parte);
        } else {
            this.checkOperacoesEmLotePartes(numeroProcesso, parte);
        }
    }

    getDescricaoExibicaoProcesso(registro) {
        let opcaoProcesso = this.opcoesProcessosEmExibicao.find(
            (opcaoProcessos) =>
                opcaoProcessos.funcaoProcessos().findIndex((reg) => reg.numeroProcesso === registro.numeroProcesso) >= 0
        );
        return opcaoProcesso ? opcaoProcesso.descricaoSingular : '';
    }

    getDescricoesOpcoesProcessos() {
        return this.opcoesProcessosEmExibicao.map((opcaoProcesso) => opcaoProcesso.descricao).join(' / ');
    }

    abrirProcesso = (registro) => {
        if (registro) {
            let processoFiltrado = this.processosFiltrados.find(
                (reg) => reg.processo.numeroCompleto === registro.processo.numeroCompleto
            );

            if (processoFiltrado) {
                this.processoExpandido = registro;
                this.processoScroll = registro;
            } else {
                this.processoModal = registro;
            }
        }
    };

    isResultadoErro(resultado) {
        return !resultado || ErrorUtil.isResultadoErro(resultado);
    }

    createReaction(disposer) {
        if (process.env.REACT_APP_ENV === 'development') {
            this.disposers.push(() => disposer);
        } else {
            this.disposers.push(disposer);
        }
        return disposer;
    }

    createWhenReaction(predicate) {
        return this.createReaction(when(predicate, { timeout: Configuracao.DEFAULT_MOBX_TIMEOUT }));
    }

    disposeReactions() {
        this.disposers.forEach((disposer) => {
            if (typeof disposer === 'function') {
                disposer();
            }
        });
        this.disposers = [];
    }
}
